export const TOUR_COMPANIES = [
  {
    key: "simpletv",
    company: "SimpleTV",
    sessionId: "demo-simpletv",
    department: "Facturación y Cobranza",
    blurb: "Operador de TV satelital de pago · Venezuela",
  },
  {
    key: "finfarma",
    company: "FinFarma",
    sessionId: "demo-finfarma",
    department: "Red de Farmacias y Droguerías",
    blurb: "Plataforma de récipe digital · Venezuela",
  },
];

export const TOUR_STEPS = [
  {
    title: "Entrevista ABC",
    path: (t) => `/informe/${t.sessionId}/entrevista`,
    targets: ['[data-testid="interview-question-highlight"]', '[data-testid="interview-transcript"]'],
    body: (t) =>
      `Transcripción completa de la entrevista a ${t.company}. Las preguntas resaltadas son los momentos clave del método ABC: contexto, métricas, cargos y el porcentaje de tiempo de cada actividad.`,
  },
  {
    title: "Informe ejecutivo",
    path: (t) => `/informe/${t.sessionId}`,
    targets: ['[data-testid="person-block"]'],
    body: (t) =>
      `La entrevista se convierte en un informe jerárquico: departamentos → personas → actividades, con su peso, herramientas y flujo. Desde la barra superior se descarga en Excel.`,
  },
  {
    title: "Flujo de actividades",
    path: (t) => `/informe/${t.sessionId}/flujo`,
    targets: ['[data-testid="flow-document-viewer"]'],
    body: (t) =>
      `El documento final de ${t.company}: el recorrido de cada cargo, actividad por actividad, con los sistemas que usa. Puede verse como imagen o como PDF y descargarse.`,
  },
  {
    title: "Agentes generados",
    path: (t) => `/informe/${t.sessionId}`,
    targets: ['[data-testid="agents-grid"]'],
    body: (t) =>
      `Por cada departamento de ${t.company} la plataforma diseñó un agente IA con un iniciador por actividad, el flujo ABC, el conocimiento de la industria y las herramientas MCP que necesita.`,
  },
  {
    title: "Herramientas MCP",
    path: (t) => `/agentes/${t.agentSlug}/mcps`,
    targets: ['[data-testid^="mcp-group-"]', '[data-testid="mcps-empty"]'],
    body: (t) =>
      `Inviktus detecta en la entrevista qué sistemas usa cada actividad y propone el conector MCP que el ${t.agentName} necesita para consultarlos y actuar.`,
  },
  {
    title: "Biblioteca KBL",
    path: (t) => `/admin/kbl?empresa=${encodeURIComponent(t.company)}`,
    targets: ['[data-testid="kbl-list"]'],
    body: (t) =>
      `Los procedimientos y manuales internos de ${t.company}, indexados para búsqueda por palabras clave y por significado. Los agentes los consultan antes de responder.`,
  },
  {
    title: "Chat con el agente",
    path: (t) => `/agentes/${t.agentSlug}?chat=${t.key}-tour`,
    targets: ['[data-testid="agent-citations"]', '[data-testid="agent-messages"]'],
    body: (t) =>
      `El ${t.agentName} responde usando los iniciadores de su actividad y cita los documentos de la biblioteca KBL de ${t.company} (RAG), para que cada respuesta sea verificable.`,
  },
  {
    title: "Métricas e impacto",
    path: (t) => `/agentes/${t.agentSlug}/metricas?ventana=6`,
    targets: ['[data-testid="agent-kpi-tiles"]'],
    body: () =>
      `Cada interacción y cada evento del webhook se transforman en impacto: horas y dólares ahorrados, tareas completadas, tasa de éxito y CSAT. Esta información alimenta el dashboard y la facturación.`,
  },
  {
    title: "Dashboard general",
    path: () => "/dashboard?ventana=6",
    targets: ['[data-testid="kpi-tiles"]'],
    body: () =>
      `La vista de dirección: todos los agentes, su uso, el ahorro acumulado y la tendencia mensual en un solo lugar, exportable a Excel y PDF.`,
  },
];
